import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Colors from '../../colors'

const Container = styled.h1`
  border-bottom: 2px solid ${Colors.secondary};
  position: relative;
  font-size: 3rem;
  text-align: left;
  padding: 5px 20px 20px 0;
  margin: 20px;
  color: ${Colors.secondary};
`

export default function Welcome({ children }) {
  return <Container>{children}</Container>
}

Welcome.propTypes = {
  children: PropTypes.node.isRequired
}
